export default __webpack_public_path__ + "static/media/wolfcaps.94af6d40.jpg";